// WebSocket instrumentado para el cliente de Convex: copia cada mensaje al
// registro de DevTools sin tocar lo que Convex envia o recibe. Se usa solo si
// DevTools esta habilitado al cargar la pagina (ver `devtoolsEnabled`).

import { devtools, type DevtoolsRegistry } from "./registry";

/** Clave de localStorage que DevTools pone cuando el usuario tiene debugMode. */
export const DEVTOOLS_FLAG = "heskala_devtools";

/** En desarrollo siempre; en produccion solo si DevTools quedo activado (debugMode). */
export function devtoolsEnabled(): boolean {
  if (import.meta.env.DEV) return true;
  try {
    return localStorage.getItem(DEVTOOLS_FLAG) === "1";
  } catch {
    return false;
  }
}

// ── Simular backend caido ─────────────────────────────────────────────────
// Corta el WebSocket de Convex y cierra cada reconexion apenas abre: la app
// ve "backend caido" y entra en modo offline, como con la red cortada. Solo
// afecta a esta pestana; al desactivarlo, el siguiente reintento conecta.

const sockets = new Set<WebSocket>();
let blocked = false;

export function isConvexBlocked(): boolean {
  return blocked;
}

export function setConvexBlocked(next: boolean): void {
  blocked = next;
  if (next) for (const s of sockets) s.close(4000, "devtools: simulando backend caido");
}

export function instrumentedWebSocket(registry: DevtoolsRegistry = devtools): typeof WebSocket {
  const Base = WebSocket;
  class DevtoolsWebSocket extends Base {
    constructor(url: string | URL, protocols?: string | string[]) {
      super(url, protocols);
      sockets.add(this);
      this.addEventListener("open", () => {
        if (blocked) this.close(4000, "devtools: simulando backend caido");
      });
      this.addEventListener("close", () => sockets.delete(this));
      this.addEventListener("message", (event) => {
        if (typeof event.data === "string") registry.recordServerMessage(event.data);
      });
      this.addEventListener("close", () => registry.socketClosed());
    }
    override send(data: string | ArrayBufferLike | Blob | ArrayBufferView) {
      if (typeof data === "string") registry.recordClientMessage(data);
      super.send(data);
    }
  }
  return DevtoolsWebSocket;
}
